import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapFilterSelectors } from '../../mappers';
import { TFilterSelector } from '../../types/filterSelectors';
import { TReduxActions } from '../../types/redux';

const defaultState: TFilterSelector[] = [];

export function filterSelectorsReducer(state: TFilterSelector[] = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapFilterSelectors(action.payload);
  }

  return state;
}
